import SettingsRow from "components/SettingsRow";
import { useAppContext } from "contexts/AppContext";
import { useFormContext } from "contexts/FormContext";
import React, { useEffect } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { Display } from "react-bootstrap-icons";

const Settings = () => {
  // contexts
  const { appState, setAppState } = useAppContext();
  const { formState, setFormState } = useFormContext();

  // functions
  const handleMode = (mode) => {
    setFormState({
      key: "settings.viewMode",
      value: mode,
    });
    localStorage.setItem("viewMode", mode);
  };

  // effects
  useEffect(() => {
    setAppState({
      key: "settings.moreSettings",
      value: () => (
        <React.Fragment>
          <SettingsRow
            Icon={Display}
            text="View Mode"
            Setting={() => (
              <ButtonGroup className="w-auto" aria-label="Basic example">
                <Button
                  size="sm"
                  variant={
                    formState.settings.viewMode === "group"
                      ? "primary"
                      : "outline-secondary"
                  }
                  onClick={() => handleMode("group")}
                >
                  Group
                </Button>
                <Button
                  size="sm"
                  variant={
                    formState.settings.viewMode === "item"
                      ? "primary"
                      : "outline-secondary"
                  }
                  onClick={() => handleMode("item")}
                >
                  Item
                </Button>
              </ButtonGroup>
            )}
          />
        </React.Fragment>
      ),
    });

    return () => {
      setAppState({
        key: "settings.moreSettings",
        value: null,
      });
    };
  }, [formState.settings.viewMode]);

  return null;
};

export default Settings;
